export const SELECT_NAME = 'Select';
export const WINDOW_PADDING = 8;
export const SCROLL_ARROW_VELOCITY = 8;
export const SCROLL_ARROW_THRESHOLD = 8;
export const MIN_HEIGHT = 80;
export const FALLBACK_THRESHOLD = 16;
export const VIEWPORT_NAME = 'SelectViewport';
